<div mat-dialog-title>
  <div
    class="header-title-container"
    [class.align-title-center]="alignTitleCenter()"
  >
    <ng-content select="[modalHeader]"></ng-content>
  </div>

  <div class="close-button-container">
    <button
      class="small-icon-button sleip-icon-button--tertiary button-no-hover-effect"
      (click)="modalDialogClosed()"
      mat-icon-button
      mat-dialog-close
    >
      <mat-icon class="icon xs">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content><ng-content></ng-content></mat-dialog-content>

<mat-dialog-actions align="center">
  <div class="modal-footer-actions-container">
    <ng-content select="[modalFooterActions]"></ng-content>
  </div>
</mat-dialog-actions>
